import { GlobalClassInstance } from "@commoncore/constants/GlobalClass";
import { FileOperationsImplementation } from "@commoncore/implementation/FileOperationsImplementation";
import { MemoryImplementation } from "@commoncore/implementation/MemoryImplementation";
import { GlobalService } from "@commoncore/services/global.service";
import { ENV_CONSTANTS } from "@env-properties/environment";
import { ENV_CONFIG } from "@env-properties/environment-config";
import { Controller } from "./Controller";

export class MemoryController extends Controller{
    public universalService:any;
    public router:any;
    public http:any;
    public static singleInstance:any = null;
    public fileOpsController:any;
    memoryImpl: any;
    localStorageSvc:any;
    listService: any;
    cleverTapEventsService:any;
    fileOperationsImplementation: any;


    public constructor(public globalService:GlobalService) {
      super(globalService);
      this.setEnvObjects(globalService)
    }

    setEnvObjects(globalService){
      this.memoryImpl =  MemoryImplementation.getInstance(globalService);
      this.fileOperationsImplementation = FileOperationsImplementation.getInstance(globalService);
      this.universalService = globalService.getUniversalServiceRef();
    }
    
    public static getInstance(globalService):MemoryController{
      if(this.singleInstance == null){
        this.singleInstance = new MemoryController(globalService);
        return this.singleInstance;
      }else{
        return this.singleInstance;
      }
    }

    async getAllMemories(memoryKey=null){
        var url= ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["allMemoriesList"];
        this.memoryImpl.setHandler(this.globalService);
        try{
          var result = await this.memoryImpl.getAllMemories(url,memoryKey);
          return Promise.resolve(result);
        }catch(err){
          console.log("expception in fetching memories list",err);
          return Promise.reject(err);
        } finally{
          this.universalService.showLoader = false;
        }
    }

    async removeMemory(memoryKey){
        var url= ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["memoryUpdate"];
        this.memoryImpl.setHandler(this.globalService);
        try{
          var result = await this.memoryImpl.removeMemories(url,memoryKey);
          return result;
        }catch(err){
          console.log("expception in removing memory",err);
          return err;
        } finally{
          this.universalService.showLoader = false;
        }
    }

    async hideMemoryObject(memoryKey,obj){
      var url= ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["memoryObjUpdate"];
      this.memoryImpl.setHandler(this.globalService);
      try{
        var result = await this.memoryImpl.hideMemoryObject(url,memoryKey,obj);
        return result;
      }catch(err){
        console.log("expception in fetching memories list",err);
        return err;
      }finally{
        this.universalService.showLoader = false;
      }
    }

    async markMemoryAsSeen(memoryKey){
      var url= ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["msgCallLogURL"] + ENV_CONFIG.commonUrls["fullScreenBannerAction"];
      this.memoryImpl.setHandler(this.globalService);
      try{
        var result = await this.memoryImpl.markMemoryAsSeen(url,memoryKey);
        return result;
      }catch(err){
        console.log("expception in fetching memories list",err);
        return err;
      }finally{
        this.universalService.showLoader = false;
      }
    }

    async sendMemoryAnalytics(payload){
      var url= ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["msgCallLogURL"] + ENV_CONFIG.commonUrls["memoryAnalytics"];
      this.memoryImpl.setHandler(this.globalService);
      try{
        var result = await this.memoryImpl.sendMemoryAnalytics(url,payload);
        return result;
      }catch(err){
        console.log("expception in sending memories analytics",err);
        return err;
      }finally{
        this.universalService.showLoader = false;
      }
    }

    async updateMemoryToggle(updateStatus){
      this.memoryImpl.setHandler(this.globalService);
      let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"]  + ENV_CONFIG.commonUrls["userFeture"] 
      try{
        var result = await this.memoryImpl.updateMemoryToggle(url,updateStatus);
        return result
      }catch(exc){
        console.log("exception in fetching selected face details",exc);
        return exc;
      }
    }

    
}